module.exports = __webpack_public_path__ + "img/activation_location.8022f452.svg";